import { Grid } from '@mui/material'
import { ICommonProduct, MCommonProduct } from '@Models/common.model'
import { useEffect, useState } from 'react'
import Product from '@Components/Product/Product'

interface IFirearms {
    data: MCommonProduct[]
}

function Firearms(props: IFirearms) {
    // core section
    const { data } = props
    const [insuranceFirearms, setInsuranceFirearms] = useState<
        MCommonProduct[]
    >([])

    // hooks section
    /**
     * perform format data when data change
     */
    useEffect(() => {
        const formattedFirearms = data?.map(
            (item: MCommonProduct) => new MCommonProduct(item)
        )
        setInsuranceFirearms(formattedFirearms || [])
        return () => {
            setInsuranceFirearms([])
        }
    }, [data])

    // main section
    return (
        <>
            {insuranceFirearms?.length ? (
                insuranceFirearms?.map(
                    (item: ICommonProduct, index: number) => (
                        <Grid
                            item
                            xs={6}
                            key={`${item.serialCode}_gun_list_item${+index}`}
                        >
                            <Product
                                product={item}
                                balance={false}
                                checkbox={false}
                            />
                        </Grid>
                    )
                )
            ) : (
                <Grid item xs={6}>
                    <div className="text-left mb-4">No data</div>
                </Grid>
            )}
        </>
    )
}

export default Firearms
